import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { useIntl } from "react-intl";

function TabNotification({ newMessage, onResetMessage }) {
    const intl = useIntl();
    const { current: originalTitle } = useRef(document.title);

    useEffect(() => {
        let interval;
        clearInterval(interval);

        if (document.hidden && !!newMessage) {
            const messageNotification = intl.formatMessage({
                id: "WEBMESSENGER.TAB_NOTIFICATION.NEW_MESSAGE",
                description: "Notification : Nouveau message",
                defaultMessage: "Nouveau message",
            });

            interval = setInterval(() => {
                if (document.title === messageNotification) {
                    document.title = originalTitle;
                } else {
                    document.title = messageNotification;
                }
            }, 1000);

            return () => clearInterval(interval);
        }

        onResetMessage();
        document.title = originalTitle;

        return () => {};
    }, [newMessage, document.hidden]);
    return null;
}

TabNotification.propTypes = {
    newMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onResetMessage: PropTypes.func,
};
export default TabNotification;
